import { ENV } from './constants';

export const LOGIN_ENDPOINT = '/authentication';

export const WEEKLY_REPORT_ENDPOINT = '/weekly';
export const PROJECTS_ENDPOINT = '/projects';
export const USERS_ENDPOINT = '/users';
export const ALLOCATIONS_ENDPOINT = '/allocations';
